<div class="question-type__text">
  <h1 class="fs__xxl">Dropdown</h1>
  <p class="fs__md">Participants choose a single answer from a dropdown menu. Useful for compact surveys with long lists of options.</p>
  <h2 class="fs__lg">Example</h2>
  <p class="fs__md">Which county do you live in?</p>
  <ul class="question-type__bullet-points">
    <li class="fs__sm">
      <span class="text fw__500">Antrim</span>
    </li>
    <li class="fs__sm">
      <span class="text fw__500">Armagh</span>
    </li>
    <li class="fs__sm">
      <span class="text fw__500">Carlow</span>
    </li>
    <li class="fs__sm">
      <span class="text fw__500">Cavan</span>
    </li>
  </ul>
</div>
